import getInvoiceValueFromBasicPrice from "./getInvoiceValueFromBasicPrice";

export default getInvoiceValueFromBasicPrice;
